import React from 'react';
import { Chart } from "react-google-charts";
import CircularProgress from '@mui/material/CircularProgress';

import Session from '../shared/Session';
import { titleCase } from '../shared/Utilities';

export default class SJChart extends React.Component<any, any> {
    slug: any = null;

    constructor(props: any) {
        super(props);
        this.state = {
            data: undefined,
            loaded: false
        };
        this.slug = props.slug;
        this.selectData();
    };

    selectData() {
        Session.api("GET", "/data/slug/" + this.slug, {}, (result: any) => {
            result.data.googleCharts = result.data.googleCharts.map((row: any, index: number) => {
                if (index === 0) return row;
                row[0] = new Date(row[0]);
                return row;
            });
            this.setState({
                data: result.data.googleCharts,
                loaded: true
            });
        });
    }

    render() {
        return this.state.data === undefined ? this.state.loaded === true ? <CircularProgress /> : <></> : <Chart
            chartType="LineChart"
            width="100%"
            height="400px"
            data={this.state.data}
            options={{
                title: this.props.title,
                curveType: "function",
                hAxis: {
                    title: titleCase(this.state.data[0][0]),
                    format: "dd/MM",
                },
                vAxis: {
                    title: titleCase(this.state.data[0][1])
                },
                legend: {
                    position: "bottom"
                },
            }}
        />;
    }
}
